/* oxlint-disable no-restricted-imports */
import * as remix from "@remix-run/react";
import * as router from "react-router-dom";

/**
 * A hook wrapping useNavigationType from Remix and react-router-dom.
 * It can be used interchangeably in a Remix or react-router-dom based SPA.
 */
const useNavigationType = (): router.NavigationType => {
  let routerNavigationType: router.NavigationType | undefined;
  let remixNavigationType: remix.NavigationType | undefined;
  let routerError: unknown;
  let remixError: unknown;

  try {
    routerNavigationType = router.useNavigationType();
  } catch (error) {
    routerError = error;
  }

  try {
    remixNavigationType = remix.useNavigationType();
  } catch (error) {
    if (!routerNavigationType) {
      remixError = error;
    }
  }

  if (routerError && remixError) {
    throw routerError instanceof Error ? routerError : new Error(String(routerError));
  }

  return (routerNavigationType || remixNavigationType) as router.NavigationType;
};

export { useNavigationType };
